import { Stocks } from '~/svgs';
import { NextLink, Translate } from '~/i18n';
import { useGetFetchQuery } from '~/hooks/use-get-fetch-query';

const EmptyState = () => {
   const data: any = useGetFetchQuery('user-profile');

   return (
      <div className="w-full h-full flex flex-col justify-center text-center items-center">
         <Stocks />
         <span className="block mt-8 mb-1 text-lg font-semibold">
            <Translate id="dashboard:sales over months" />
         </span>
         <span className="text-gray-300 font-medium text-sm max-w-md">
            <Translate id="dashboard:You have no recent bookings" />
         </span>
         <NextLink
            className={`flex items-center bg-primary text-white px-4 py-2 rounded-md h-12 font-semibold hover:bg-blue-light mt-10 ${
               !!(data?.status !== 'Active') && 'opacity-50 pointer-events-none'
            }`}
            href={`/products`}>
            <Translate id="createproduct:create product" />
         </NextLink>
      </div>
   );
};

export default EmptyState;
